<template>
  
  <div>

    <div class="ui large breadcrumb">
      <router-link to="/financial/customer-invoices" class="clickable">
        <i class="reply icon m-r-5"></i> Fechamentos
      </router-link>
      <i class="right chevron icon divider"></i>
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui four steps m-t-5">
      <div v-for="(step, index) in steps" class="step clickable" :key="index"
        :class="{ active: activeStep == index, disabled: activeStep < index }" @click="setStep(index)">
        <i v-if="activeStep > index" class="check green icon"></i>
        <i v-else :class="step.icon"></i>        
        <div class="content">
          <div class="title">{{ step.title }}</div>
          <div class="description">{{ step.description }}</div>
        </div>
      </div>
    </div>

    <filter-step v-show="activeStep == 0" @onForward="onFilterForward" />

    <customer-step v-if="activeStep == 1" :filter="filter" @onBack="stepBack()" @onForward="onCustomerForward" />

    <certs-step v-if="activeStep == 2" :filter="filter" :customer="customer" @onBack="stepBack()" @onForward="onCertsForward" />

    <confirmation-step v-if="activeStep == 3" :filter="filter" :customer="customer" 
      :certs="certs" :resume="resume" :totals="totals" @onBack="stepBack()" />

  </div>

</template>

<script>

  import onlyFinancial from "@/mixins/only-financial"
  import AppBrowser from "@/utils/browser"
  import BookmarkButton from "@/components/bookmark-button"
  import FilterStep from "./filter"
  import CustomerStep from "./customer"
  import CertsStep from "./certs"
  import ConfirmationStep from "./confirmation"

  export default {
    
    name: "NewCustomerInvoicePage",

    mixins: [onlyFinancial],

    data() {
      return {
        title: "Novo Fechamento de Cliente",
        activeStep: 0,
        steps: [
          { title: "Filtro", description: "Defina os critérios do fechamento", icon: "filter icon" },
          { title: "Cliente", description: "Selecione o cliente", icon: "search icon" },
          { title: "Laudos", description: "Selecione os laudos", icon: "file alternate outline icon" },
          { title: "Confirmação", description: "Confirme os dados do fechamento", icon: "check circle icon" },
        ],
        filter: null,
        customer: null,
        certs: null,
        resume: null,
        totals: null,
      }
    },

    components: {
      BookmarkButton,
      FilterStep,
      CustomerStep,
      CertsStep,
      ConfirmationStep,
    },

    methods: {

      onFilterForward(filter) {
        
        this.filter = filter

        this.stepForward()
      },

      onCustomerForward(selectedCustomer) {

        this.customer = selectedCustomer

        this.stepForward()
      },

      onCertsForward(data) {

        this.certs = data.selectedCerts.slice()
        this.resume = data.resume.slice()
        this.totals = data.totals

        this.stepForward()
      },

      setStep(activeStep) {

        this.activeStep = activeStep

        AppBrowser.scrollTop()
      },

      stepBack() {
        
        this.activeStep--
        
        AppBrowser.scrollTop()
      },

      stepForward() {
        
        this.activeStep++

        AppBrowser.scrollTop()
      },
    },
  }

</script>